import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72152772"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "dropzone",
  class: "drop-zone p-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon-f x48 icon-drag",
  style: {"margin-top":"26px"}
}, null, -1))
const _hoisted_3 = ["disabled", "accept"]
const _hoisted_4 = {
  key: 0,
  class: "drop-text"
}
const _hoisted_5 = {
  key: 1,
  class: "drop-text"
}
const _hoisted_6 = {
  key: 2,
  class: "drop-text-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "document-form",
      onSubmit: _cache[1] || (_cache[1] = (e) => e.preventDefault())
    }, [
      _hoisted_2,
      _createElementVNode("input", {
        ref: "fileinput",
        type: "file",
        class: "input-file d-none",
        disabled: _ctx.disabled,
        accept: _ctx.accept,
        role: "button",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args)))
      }, null, 40, _hoisted_3),
      (_ctx.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.value.name), 1))
        : (_ctx.dragtext)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.dragtext), 1))
          : _createCommentVNode("", true),
      (_ctx.filesize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.filesize) + " Kb", 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {
        disabled: _ctx.disabled,
        click: _ctx.open
      }, undefined, true)
    ], 32)
  ], 512))
}